module.exports = __webpack_public_path__ + "img/trash_btn_dummy.c28c80b1.png";